import React, { useState } from 'react';

export default function Contact({ navigate }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = () => {
    if (!name || !email || !message) {
      alert('Please fill out all fields.');
      return;
    }
    const subject = encodeURIComponent('UmpBuddy Feedback');
    const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\n${message}`);
    window.location.href = `mailto:davidvanto@gmail.com?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <div className="screen">
      <div className="header">
        <button className="header-back" onClick={() => navigate('landing')}>‹</button>
        <span className="header-title">Contact Us</span>
      </div>

      <div className="scroll-content" style={{ padding: '24px' }}>
        {sent ? (
          <div style={{ textAlign: 'center', padding: '48px 0', display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'center' }}>
            <div style={{ fontSize: 48 }}>✅</div>
            <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 28, letterSpacing: 2, color: 'var(--green)' }}>Thanks!</div>
            <div style={{ color: 'var(--gray)', fontSize: 14 }}>We'll get back to you soon.</div>
            <button className="btn btn-ghost" onClick={() => navigate('landing')} style={{ marginTop: 16 }}>Back to Home</button>
          </div>
        ) : (
          <>
            <p style={{ color: 'var(--gray)', fontSize: 14, lineHeight: 1.7, marginBottom: 24 }}>
              Have a question, suggestion, or found a bug? We'd love to hear from you.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div className="form-group">
                <label className="form-label">Your Name</label>
                <input className="form-input" placeholder="Name" value={name} onChange={e => setName(e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Email Address</label>
                <input className="form-input" placeholder="email@example.com" type="email" value={email} onChange={e => setEmail(e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea
                  className="form-input"
                  placeholder="Your message..."
                  rows={5}
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  style={{ resize: 'none', lineHeight: 1.6 }}
                />
              </div>
              <button className="btn btn-primary" onClick={handleSubmit}>Send Message →</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
